import React from "react";
import { useSelector } from "react-redux";

import Pattern from "./Pattern/Pattern";

import { selectPatternIds } from "../../../../redux/slices/coldStart";

import { usePatternInteractions } from "../hooks/usePatternInteraction";
import { useContainerHeight } from "../../../GlobalHooks/useContainerHeight";

const PADDING_BORDERS_MARGINS = 26;

export default function SavedPatterns() {
  const patternsIds = useSelector(selectPatternIds);
  const selected = useSelector(({ coldStart }) => coldStart.selected);
  const display = useSelector(({ display }) => display.display);

  const height = useContainerHeight("#coldStartSavedPatterns");

  const { onClick, onDelete } = usePatternInteractions();

  return (
    <Pattern
      key={patternsIds[0]}
      id={patternsIds[0]}
      height={height - PADDING_BORDERS_MARGINS}
      selected={patternsIds[0] === selected}
      onClick={onClick}
      onDelete={onDelete}
      display={display}
    />
  );
}
